import React from "react";
import { Field } from "react-final-form";
import { InstrumentSelectField } from "@syos-music/instruments";

import { Grid } from "@mui/material";

import LegacyMouthpieceField from "components/mouthpiece/LegacyMouthpieceField";
import ClarinetMouthpieceField from "components/mouthpiece/ClarinetMouthpieceField";
import SaxophoneMouthpieceField from "components/mouthpiece/SaxophoneMouthpieceField";

export default function MouthpieceField({ name, required, type, ...props }) {
  return (
    <Field name={name} {...props}>
      {({ input: { value } }) => {
        let mouthpieceType = type || value.type;

        return (
          <Grid container>
            <Grid item xs={12}>
              {!type && (
                <InstrumentSelectField
                  name={`${name}.type`}
                  required={required}
                  parse={(value) => {
                    switch (value) {
                      case "clarinet":
                        return "clarinetMouthpiece";
                      case "saxophone":
                        return "saxophoneMouthpiece";

                      default:
                        return null;
                    }
                  }}
                  format={(value) => {
                    switch (value) {
                      case "clarinetMouthpiece":
                        return "clarinet";
                      case "saxophoneMouthpiece":
                        return "saxophone";

                      default:
                        return null;
                    }
                  }}
                />
              )}
            </Grid>

            {!!mouthpieceType && (
              <Grid item xs={12}>
                {mouthpieceType === "legacyMouthpiece" && (
                  <LegacyMouthpieceField
                    name={`${name}.legacyMouthpiece`}
                    required={required}
                  />
                )}
                {mouthpieceType === "clarinetMouthpiece" && (
                  <ClarinetMouthpieceField
                    name={`${name}.clarinetMouthpiece`}
                    required={required}
                  />
                )}
                {mouthpieceType === "saxophoneMouthpiece" && (
                  <SaxophoneMouthpieceField
                    name={`${name}.saxophoneMouthpiece`}
                    required={required}
                  />
                )}
              </Grid>
            )}
          </Grid>
        );
      }}
    </Field>
  );
}
